import { css } from 'emotion';

export const alertItemWrapper = (color: string) => css`
  width: 410px;
  min-height: 64px;
  box-sizing: border-box;
  background: ${color};
  overflow: hidden;
  display: flex;
  align-items: center;
  padding: 20px 10px 20px 20px;
  border-radius: 5px;
  position: relative;
  margin-bottom: 15px;
  box-shadow:
    0 1px 10px 0 rgb(0 0 0 / 10%),
    0 2px 15px 0 rgb(0 0 0 / 5%);

  :hover {
    #progress-bar {
      animation-play-state: paused;
    }
  }
`;
